import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import MatTableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import ArrowIcon from '@material-ui/icons/KeyboardArrowDown';
import Checkbox from '../../../components/CustomCheckbox';
import { Order } from '../../../utils/table';
import { Customer } from '../../../types/Customer';

type Props = {
  onSelectAllClick: (e: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: keyof Customer | string;
  numSelected: number;
  rowCount: number;
  onRequestSort: (
    event: React.SyntheticEvent,
    property: keyof Customer
  ) => void;
};

type HeadRow = {
  id: keyof Customer;
  align: 'left' | 'center' | 'right';
  disablePadding: boolean;
  label: string;
};

const headRows: Array<HeadRow> = [
  {
    id: 'firstname',
    align: 'right',
    disablePadding: false,
    label: 'First Name',
  },
  {
    id: 'lastname',
    align: 'right',
    disablePadding: false,
    label: 'Last Name',
  },
  {
    id: 'visitor_contact_status_id',
    align: 'right',
    disablePadding: false,
    label: 'Contact status',
  },
  {
    id: 'cell_phone_1',
    align: 'center',
    disablePadding: false,
    label: 'Cell phone',
  },
  {
    id: 'visitor_type_id',
    align: 'center',
    disablePadding: true,
    label: 'Visitor Type',
  },
  {
    id: 'total_visits',
    align: 'center',
    disablePadding: true,
    label: 'Visit Counter',
  },
  {
    id: 'modified_on',
    align: 'center',
    disablePadding: false,
    label: 'Last Use',
  },
  {
    id: 'last_property',
    align: 'right',
    disablePadding: false,
    label: 'Last Property',
  },
  {
    id: 'last_status',
    align: 'right',
    disablePadding: false,
    label: 'Last Visit Status',
  },
  {
    id: 'created_on',
    align: 'right',
    disablePadding: false,
    label: 'First Use',
  },
];

const TableHead: React.FC<Props> = props => {
  const {
    onRequestSort,
    onSelectAllClick,
    orderBy,
    order,
    numSelected,
    rowCount,
  } = props;

  const createSortHandler = (property: keyof Customer) => (
    event: React.SyntheticEvent,
  ): void => {
    onRequestSort(event, property);
  };

  return (
    <MatTableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'Select all Properties' }}
          />
        </TableCell>
        {headRows.map(({
          id, align, disablePadding, label,
        }) => (
          <TableCell
            key={id}
            align={align}
            padding={disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === id ? order : false}
            onClick={createSortHandler(id)}
          >
            {label}
            <TableSortLabel
              active={orderBy === id}
              direction={order}
              IconComponent={ArrowIcon}
            />
          </TableCell>
        ))}
      </TableRow>
    </MatTableHead>
  );
};

export default React.memo(TableHead);
